class PromptController {

  constructor(close, authenticateApi, storeService, basket, basketApiService, loginoutService, $window) {
    this.close = close;
    this.authenticateApi = authenticateApi;
    this.storeService = storeService;
    this.basket = basket;
    this.basketApiService = basketApiService;
    this.loginoutService = loginoutService;
    this.$window = $window;
  }

  login () {
    this.error = null;

    if (this.email && this.password && !this.storeService.get('client_id')) {
      this.saving = true;

      return this.authenticateApi.login({
        EmailAddress: this.email,
        Password: this.password,
        basketCode: this.basket.contents.identity_code
      })
        .then(response => {
          if (!response || !response.client) {
            throw 'Invalid response';
          }

          this.storeService.set('client_id', response.client);
          this.storeService.set('client_name', response.name);
          this.storeService.set('basket', response.basket);
          this.success = `Welcome back, ${response.name || ''}...`;

          this.close(true, 1500);

          return this.basket.getApiBasket();
        })
        .catch(() => {
          this.error = "Sorry, we did not recognise those details, please try again.";
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  logout () {
    if (this.storeService.get('client_name')) {
      this.saving = true;

      return new Promise(resolve => {
        this.storeService.remove('client_id');
        this.storeService.remove('client_name');
        this.loginoutService.removeReservationData();

        return this.resetBasket()
          .then(() => {
            resolve();
          });
      })
        .then(() => {
          return this.close(true);
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  editReservation () {
    this.error = null;

    if (this.reference && this.surname && this.date) {
      this.saving = true;

      return this.authenticateApi.byReference({
        reference: this.reference,
        surname: this.surname,
        date: this.date,
        basketCode: this.basket.contents.identity_code
      })
        .then(response => {
          this.storeService.set('reservation', response.reference);
          this.storeService.set('client_name', response.name);
          this.storeService.set('basket', response.basket);
          this.storeService.set('start_date', response.startDate);
          this.storeService.set('end_date', response.endDate);
          this.storeService.set('searchDate', response.startDate);

          return this.goToManageBooking();
        })
        .catch((error) => {
          this.error = 'Sorry, we could not authenticate you with those details';
          this.saving = false;
        });
    }
  }

  resetBasket () {
    this.storeService.set('basket', '');

    return this.basketApiService.deleteBasket(this.basket.contents.identity_code)
      .then(() => {
        return this.basket.getApiBasket();
      })
      .catch(() => { });
  }

  isGuestAllowed () {
    return !this.loginoutService.isRequired();
  }

  closePrompt () {
    this.close(this.isGuestAllowed());
  }

  setTab (param) {
    this.error = '';
    this.tab = param;
  }

  activeTab (param) {
    return this.tab === param;
  }

  goToManageBooking () {
    return this.$window.location = '/manage-booking';
  }

  canRegister() {
    return this.loginoutService.canRegister();
  }
}

PromptController.$inject = [ 'close', 'authenticateApi', 'storeService', 'basket', 'basketApiService', 'loginoutService', '$window' ];

export default PromptController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/controllers/prompt.controller.js